import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { environment } from '../../../../../../contract-frontend/src/environments/environment';
import { AuthService } from '../auth.service';

export const AUTH_GUARD = (route: ActivatedRouteSnapshot) => {
  const authService = inject(AuthService);
  const token = authService.getToken();
  if (route.queryParamMap.get('_nav_t')) {
    window.location.href = `${environment.url}?_nav_t=${route.queryParamMap.get(
      '_nav_t',
    )}&redirect_uri=${environment.url}${window.location.pathname}`;
    return;
  }
  return token ? true : (window.location.href = environment.workspaceUrl);
};
